import { saveAs } from "file-saver";

export default {
  /**
   * 現在の画面を再描画する。
   */
  reloadRouter() {
    window.reloadRouter();
  },
  /**
   * オブジェクトに空ではないプロパティがあるかどうか判断する。
   * @param obj
   * @returns {boolean}
   */
  isNotNullORBlank(obj) {
    let result = false;
    for (const key in obj) {
      if (obj[key] !== "") {
        result = true;
        break;
      }
    }
    return result;
  },
  /**
   * 漢字かどうかを判断する。
   * @param str
   * @returns {boolean}
   */
  isKanji(str) {
    const regexp =
      /([\u{3005}\u{3007}\u{303b}\u{3400}-\u{9FFF}\u{F900}-\u{FAFF}\u{20000}-\u{2FFFF}][\u{E0100}-\u{E01EF}\u{FE00}-\u{FE02}]?)/mu;
    return regexp.test(str);
  },
  /**
   * 仮名かどうかを判断する。
   * @param str
   * @returns {boolean}
   */
  isKana(str) {
    const hirakana_regexp = /[\u{3000}-\u{301C}\u{3041}-\u{3093}\u{309B}-\u{309E}]/mu;
    const kanakana_regexp = /[\u{3000}-\u{301C}\u{30A1}-\u{30F6}\u{30FB}-\u{30FE}]/mu;
    return hirakana_regexp.test(str) || kanakana_regexp.test(str);
  },

  isPhoneNo(str) {
    const regexp = /^0\d{9,10}$/;
    return regexp.test(str);
  },

  /**
   * モバイル機器かどうかを判断する
   * @returns {boolean}
   */
  isMobile() {
    return navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
  },
  /**
   * beanCopy
   * @param arrA to
   * @param arrB from
   * @param copyEmp boolean
   */
  beanCopy(arrA, arrB, copyEmp) {
    Object.keys(arrA).forEach((key) => {
      if (copyEmp) {
        arrA[key] = arrB[key];
      } else {
        arrA[key] = arrB[key] || arrB[key] === 0 ? arrB[key] : arrA[key];
      }
    });
  },
  /**
   * リスト中に特定の値が存在するかどうか
   * @param list
   * @param type 検索するフィールド
   * @param key
   * @returns {boolean|*}
   */
  masterListExistData(list, type, key) {
    if (!list) {
      return false;
    }
    return list.find((entity) => entity[type] === key);
  },
  /**
   * override v-data-table search
   * @param value
   * @param search
   * @param item
   * @param checkObj
   * @param subObj
   * @returns {boolean}
   */
  searchFilter(value, search, item, checkObj, subObj) {
    if (!search) {
      return true;
    }
    this.beanCopy(checkObj, item, false);

    for (let prop in checkObj) {
      //array
      if (checkObj[prop] instanceof Array) {
        for (let subData of checkObj[prop]) {
          this.beanCopy(subObj, subData, false);
          for (let subProp in subObj) {
            if (subObj[subProp].includes(search)) {
              return true;
            }
          }
        }
      }
      //String
      if (checkObj[prop].includes(search)) {
        return true;
      }
    }
    return false;
  },
  /**
   * ディープコピー
   */
  deepCopy(data) {
    return JSON.parse(JSON.stringify(data));
  },
  /**
   * 日付を変換する。
   * @param date
   * @param type
   * @returns {string}
   */
  dateStrFormat(date, type) {
    return date.replaceAll("-", type).replaceAll("/", type);
  },
  /**
   * Chip淡色対応
   * @param colorCode
   * @returns {string|string}
   */
  getChipColor(colorCode) {
    if (!colorCode) {
      return "white";
    }
    colorCode = colorCode.substring(1);
    let rgb = parseInt(colorCode, 16);
    let r = (rgb >> 16) & 0xff;
    let g = (rgb >> 8) & 0xff;
    let b = rgb & 0xff;
    let brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 220 ? "black" : "white";
  },
  /**
   * (姓)+separator+(名)
   */
  mergeName(familyName, firstName, separator) {
    if (!separator && separator !== "") {
      separator = " ";
    }
    let result = "";
    if (familyName) {
      result += familyName;
    }
    if (firstName) {
      if (result) {
        result += separator;
      }
      result += firstName;
    }
    return result;
  },
  /**
   * 顧客姓名
   * @param familyName
   * @param firstName
   * @param customerKindCd
   * @param separator
   */
  mergeCustomerName(familyName, firstName, customerKindCd, separator) {
    let customerName;
    if (customerKindCd === 1) {
      customerName = this.mergeName(familyName, firstName, separator);
    } else {
      customerName = familyName;
    }
    return customerName;
  },
  /**
   * 更改状況設定
   * @param renewalStatus
   * @returns {string}
   */
  getShowRenewalStatus(renewalStatus) {
    if (!renewalStatus) {
      return "";
    }
    switch (renewalStatus) {
      case "1":
        return "対応不要";
      case "2":
        return "案件化せず対応中";
      case "3":
        return "案件作成済み";
      case "4":
        return "更改済";
      case "5":
        return "他損保更改済み";
      case "6":
        return "更改落ち";
    }
    return "";
  },
  /**
   * ファイルのダウンロード。
   * @param response
   */
  saveDownloadedFile(response) {
    if (response.type === "application/json") {
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        alert(JSON.parse(fileReader.result).msg);
      };
      fileReader.readAsText(response);
      return false;
    }
    //console.log(response);
    const blob = new Blob([response.data], {
      type: response.data.type
    });

    const contentDisposition = response.headers["content-disposition"];
    //console.log(contentDisposition);
    let contentDispositions = contentDisposition.split(";");
    let fileNames = contentDispositions[contentDispositions.length - 1].split("=");
    let fileName = fileNames[fileNames.length - 1];
    //デコードするとスペースが"+"になるのでスペースへ置換します
    fileName = decodeURI(fileName).replace(/\+/g, " ");
    //console.log(fileName);
    saveAs(blob, fileName);
    return true;
  },
  /**
   * ダウンロードファイルを新タブで開く
   * @param response
   */
  openDownloadedFile(response) {
    if (response.type === "application/json") {
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        alert(JSON.parse(fileReader.result).msg);
      };
      fileReader.readAsText(response);
      return false;
    }
    //console.log(response);
    const blob = new Blob([response.data], {
      type: response.data.type
    });

    const contentDisposition = response.headers["content-disposition"];
    //console.log(contentDisposition);
    let contentDispositions = contentDisposition.split(";");
    let fileNames = contentDispositions[contentDispositions.length - 1].split("=");
    let fileName = fileNames[fileNames.length - 1];
    //デコードするとスペースが"+"になるのでスペースへ置換します
    fileName = decodeURI(fileName).replace(/\+/g, " ");

    /*
    let url = window.URL.createObjectURL(blob);
    let child = window.open(url, "_blank");

    //下記のタイトルの設定が効かない
    setTimeout(function () {
      child.document.title = fileName;
    }, 500);
    */

    let newWindow = window.open();

    setTimeout(() => {
      newWindow.document.title = fileName;
    }, 500);

    newWindow.document.write(
      `<style>body {margin: 0 !important;}</style> <iframe src="${URL.createObjectURL(
        blob
      )}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`
    );
    return true;
  },
  isNumber(value) {
    return /^[0-9]+$/.test(value);
  },
  toZenkakuKana(str) {
    const kanaMap = {
      ｶﾞ: "ガ",
      ｷﾞ: "ギ",
      ｸﾞ: "グ",
      ｹﾞ: "ゲ",
      ｺﾞ: "ゴ",
      ｻﾞ: "ザ",
      ｼﾞ: "ジ",
      ｽﾞ: "ズ",
      ｾﾞ: "ゼ",
      ｿﾞ: "ゾ",
      ﾀﾞ: "ダ",
      ﾁﾞ: "ヂ",
      ﾂﾞ: "ヅ",
      ﾃﾞ: "デ",
      ﾄﾞ: "ド",
      ﾊﾞ: "バ",
      ﾋﾞ: "ビ",
      ﾌﾞ: "ブ",
      ﾍﾞ: "ベ",
      ﾎﾞ: "ボ",
      ﾊﾟ: "パ",
      ﾋﾟ: "ピ",
      ﾌﾟ: "プ",
      ﾍﾟ: "ペ",
      ﾎﾟ: "ポ",
      ｳﾞ: "ヴ",
      ﾜﾞ: "ヷ",
      ｦﾞ: "ヺ",
      ｱ: "ア",
      ｲ: "イ",
      ｳ: "ウ",
      ｴ: "エ",
      ｵ: "オ",
      ｶ: "カ",
      ｷ: "キ",
      ｸ: "ク",
      ｹ: "ケ",
      ｺ: "コ",
      ｻ: "サ",
      ｼ: "シ",
      ｽ: "ス",
      ｾ: "セ",
      ｿ: "ソ",
      ﾀ: "タ",
      ﾁ: "チ",
      ﾂ: "ツ",
      ﾃ: "テ",
      ﾄ: "ト",
      ﾅ: "ナ",
      ﾆ: "ニ",
      ﾇ: "ヌ",
      ﾈ: "ネ",
      ﾉ: "ノ",
      ﾊ: "ハ",
      ﾋ: "ヒ",
      ﾌ: "フ",
      ﾍ: "ヘ",
      ﾎ: "ホ",
      ﾏ: "マ",
      ﾐ: "ミ",
      ﾑ: "ム",
      ﾒ: "メ",
      ﾓ: "モ",
      ﾔ: "ヤ",
      ﾕ: "ユ",
      ﾖ: "ヨ",
      ﾗ: "ラ",
      ﾘ: "リ",
      ﾙ: "ル",
      ﾚ: "レ",
      ﾛ: "ロ",
      ﾜ: "ワ",
      ｦ: "ヲ",
      ﾝ: "ン",
      ｧ: "ァ",
      ｨ: "ィ",
      ｩ: "ゥ",
      ｪ: "ェ",
      ｫ: "ォ",
      ｯ: "ッ",
      ｬ: "ャ",
      ｭ: "ュ",
      ｮ: "ョ",
      "｡": "。",
      "｢": "「",
      "｣": "」",
      "､": "、",
      "･": "・",
      ｰ: "ー",
      " ": "　"
    };

    const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const kanaRegex = new RegExp(Object.keys(kanaMap).map(escapeRegExp).join("|"), "g");
    return str.replace(kanaRegex, (m) => kanaMap[m]);
  }
};
